import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { MUSTNeverHappenException } from '@nu-art/ts-common';
import { Dialog_Confirmation } from '@app/styles';
import { ModuleFE_Pathway } from '../../_entity/pathway/index.js';
export const detachPathwayFromParent = async (pathwayId) => {
    if (!pathwayId)
        return;
    const pathway = ModuleFE_Pathway.cache.unique(pathwayId);
    if (!pathway)
        throw new MUSTNeverHappenException(`cannot find pathway with id ${pathwayId}`);
    const isParent = ModuleFE_Pathway.isParent(pathwayId);
    const hasNoParent = !pathway._parentId;
    if (isParent || hasNoParent)
        return;
    return new Promise((resolve) => {
        Dialog_Confirmation.show({
            content: _jsx(_Fragment, { children: _jsx("div", { children: "By changing organization permissions to this protocol, it'll be detached from its parent and will not receive updates" }) }),
            buttons: [
                {
                    label: 'Yes, Change Org Permissions',
                    isAsync: true,
                    action: async () => {
                        await ModuleFE_Pathway._v1.detachPathwayFromParent({ pathwayId }).executeSync();
                        resolve(true);
                    }
                },
                {
                    label: 'Cancel', isPreferred: true, action: () => {
                        resolve(false);
                    }
                }
            ]
        });
    });
};
//# sourceMappingURL=ui-utils.js.map